
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/subscriptions",
      function () {
        return require("private-next-pages/profile/subscriptions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/subscriptions"])
      });
    }
  